// 8 - 32 chars long
// one lowercase character
// one uppercase character
// one number
// one non word character + underscore
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,32}$/
